import script from "./AiMemoryPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AiMemoryPanel.vue?vue&type=script&setup=true&lang=js"

import "./AiMemoryPanel.vue?vue&type=style&index=0&id=3e87f2d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e87f2d2"]])

export default __exports__